/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Request object for adding feedback to a meal insight
 */
export type AddMealInsightFeedbackRequest = {
    /**
     * Rating for the meal insight
     */
    rating: AddMealInsightFeedbackRequest.rating;
};

export namespace AddMealInsightFeedbackRequest {

    /**
     * Rating for the meal insight
     */
    export enum rating {
        GOOD = 'GOOD',
        BAD = 'BAD',
        REMOVED = 'REMOVED',
    }


}

